import React from "react";
import Navigation from "./Navigation";
import Breaker from "./Breaker";
import Foot from "./Foot";

class ImportExport extends React.Component {
    componentDidMount() {
        const { titleChange } = this.props;
        titleChange(`Import & Export`);
    }

    exportWatchedList = () => {
        /**
         * Blob for immutable file-like object - https://devdocs.io/dom/blob
         * Creating a hidden link element - https://devdocs.io/dom/document/createelement
         * Attributes - https://devdocs.io/html/element/link
         */
        const { favorites, watched } = this.props;

        if (watched.length > 0) {
            let moviesToExport = JSON.stringify({
                favorites,
                watched: watched
            });
            let exportFileName =
                new Date()
                    .toJSON()
                    .slice(0, 10)
                    .replace(/\//g, "-") + ".json";
            let blob = new Blob([moviesToExport], {
                type: "text/json;charset=utf-8;"
            });

            console.log(moviesToExport);

            let downloadLink = document.createElement("a");
            let url = URL.createObjectURL(blob);
            downloadLink.setAttribute("href", url);
            downloadLink.setAttribute("download", exportFileName);
            downloadLink.style.visibility = "hidden";
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
            console.log(
                `Exported your watched movies list as ${exportFileName}.`
            );
        } else {
            console.log(
                `You have an empty watched movies list with count of ${
                    watched.length
                }, add some first!`
            );
        }
    };

    newFileUploadedEvent = evt => {
        const { onImported } = this.props;
        console.log(evt.target.files);
        let fileReader = new FileReader();
        fileReader.onload = function(fileLoadedEvent) {
            let textFromFileLoaded = fileReader.result;
            onImported(JSON.parse(textFromFileLoaded));
        };
        fileReader.readAsBinaryString(evt.target.files[0]);
    };

    render() {
        const {
            onSearch,
            totalFavorites,
            totalWatched,
            searchKeyUpdate
        } = this.props;
        return (
            <div>
                <Navigation
                    onSearch={onSearch}
                    totalFavorites={totalFavorites}
                    searchKeyUpdate={searchKeyUpdate}
                    totalWatched={totalWatched}
                />

                <div className="container">
                    <Breaker title="Import or Export" />
                    <div className="movies">
                        <fieldset>
                            <legend>Import</legend>
                            <div className="file-upload">
                                <button
                                    onClick={() => console.log("No!")}
                                    htmlFor="tm-file"
                                >
                                    <span className="icon-note-important" />&nbsp;Import
                                    your data.
                                </button>
                                <input
                                    type="file"
                                    name="file"
                                    id="file"
                                    accept=".json"
                                    onChange={evt =>
                                        this.newFileUploadedEvent(evt)
                                    }
                                />
                            </div>
                        </fieldset>
                        <fieldset>
                            <legend>Export</legend>
                            <div>
                                <button onClick={this.exportWatchedList}>
                                    <span className="icon-warning" /> Export all
                                    data.
                                </button>
                            </div>
                        </fieldset>
                    </div>
                    <Foot />
                </div>
            </div>
        );
    }
}

export default ImportExport;



// WEBPACK FOOTER //
// ./src/components/ImportExport.js